import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DB2547",
      d: "M12 6.839a.875.875 0 0 0-.875.875v5.436a.887.887 0 0 0 .875.875.887.887 0 0 0 .875-.875V7.714A.875.875 0 0 0 12 6.839m0 8.573a.887.887 0 0 1 .875.875.875.875 0 1 1-1.75 0 .887.887 0 0 1 .875-.875"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DB2547",
      "fill-rule": "evenodd",
      d: "M12 3.773a8.227 8.227 0 1 0 0 16.454 8.227 8.227 0 0 0 0-16.454M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }